export const footer = {
    title: "Copyright © 2023 Anayo Oleru",
    terms_and_conditions: "Terms And Conditions",
    policy: "Policy",
    faq: "FAQ"
};
